module.exports = __webpack_public_path__ + "28e4b95e4b42f8e30b431cfc3ff896e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/LisaDaly.jpg
// module id = 1073
// module chunks = 0